import { render, staticRenderFns } from "./PrintWarrantyReception.vue?vue&type=template&id=28ffdb71&scoped=true"
import script from "./PrintWarrantyReception.vue?vue&type=script&lang=js"
export * from "./PrintWarrantyReception.vue?vue&type=script&lang=js"
import style0 from "./PrintWarrantyReception.vue?vue&type=style&index=0&id=28ffdb71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ffdb71",
  null
  
)

export default component.exports